/**
 * Copy text to the clipboard and report whether it actually worked.
 * Clipboard API first (needs a secure context + permission), then the
 * execCommand fallback for http/older WebViews. Callers use the boolean to
 * show honest feedback — never claim "Copied" when nothing was copied.
 */
export const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
        return true;
    } catch {
        const ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        let ok = false;
        try { ok = document.execCommand('copy'); } catch { ok = false; }
        document.body.removeChild(ta);
        return ok;
    }
};
